import { ErrorMessage, useFormikContext } from "formik";
import { CardBody, CardHeader, Col, FormGroup, Row } from "reactstrap";
import organizationData from "../../../utils/organizationData.json";
import { OrganizationFormData } from "../../../types/organization/OrganizationTypes";
// import Select from "react-select";
import { customReactSelectStyles } from "../../../styles/ReactSelectStyles";
import { useTranslation } from "react-i18next";
import { DateFormatPlaceholder } from "../../../utils/Constant";
import {Typeahead} from "react-bootstrap-typeahead";


interface GeneralSettingsSectionProps {
  isEdit?: boolean;
}

const GeneralSettingsSection = ({ isEdit, }: GeneralSettingsSectionProps) => {
  const { t } = useTranslation();
  const { setFieldValue, values } = useFormikContext<OrganizationFormData>();

  return (
    <div className="mb-4">
      <CardHeader>
        <h5>General Settings</h5>
      </CardHeader>
      <CardBody>
        <Row>
          <Col sm="4">
            <FormGroup>
              <label>{t("OrganizationTimezone")} <span className="txt-danger">*</span></label>
              <Typeahead
                id="timezone-typeahead"
                labelKey="label"
                options={organizationData.timezones}
                placeholder={t("OrganizationTimezonePlaceholder")}
                selected={
                  values.timezone
                    ? organizationData.timezones.filter(opt => opt.value === values.timezone)
                    : []
                }
                onChange={selected => {
                  const timezone = selected[0] as { value: string } | undefined;
                  setFieldValue('timezone', timezone ? timezone.value : '');
                }}
                clearButton
              />
              <ErrorMessage
                name="timezone"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>

          <Col sm="4">
            <FormGroup>
              <label>{t("OrganizationCurrency")} <span className="txt-danger">*</span></label>
              <Typeahead
                id="currency-typeahead"
                labelKey="label"
                options={organizationData.currencies}
                placeholder={t("OrganizationCurrencyPlaceholder")}
                selected={
                  values.currency
                    ? organizationData.currencies.filter(opt => opt.value === values.currency)
                    : []
                }
                onChange={selected => {
                  const currency = selected[0] as { value: string } | undefined;
                  setFieldValue('currency', currency ? currency.value : '');
                }}
                renderMenuItemChildren={option => {
                  if (typeof option === 'string') return <span>{option}</span>;
                  return (
                    <div className="d-flex align-items-center">
                      {option.symbol && (
                        <span style={{ marginRight: 8 }}>{option.symbol}</span>
                      )}
                      <span>{option.label}</span>
                    </div>
                  );
                }}
                clearButton
              />
              <ErrorMessage
                name="currency"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>

          <Col sm="4">
            <FormGroup>
              <label>{t("PageLimit")} <span className="txt-danger">*</span></label>
              <Typeahead
                id="pagelimit-typeahead"
                labelKey="label"
                options={organizationData.PageLimit}
                placeholder={t("PageLimitPlaceholder")}
                selected={
                  values.PageLimit
                    ? organizationData.PageLimit.filter(opt => opt.value === values.PageLimit)
                    : []
                }
                onChange={selected => {
                  const pageLimit = selected[0] as { value: string } | undefined;
                  setFieldValue('PageLimit', pageLimit ? pageLimit.value : '');
                }}
                clearButton
              />
              <ErrorMessage
                name="pageLimit"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>

          <Col sm="4">
            <FormGroup>
              <label>{t("DateFormat")} <span className="txt-danger">*</span></label>
              <Typeahead
                id="dateformat-typeahead"
                labelKey="label"
                options={organizationData.DateFormat}
                placeholder={t(DateFormatPlaceholder)}
                selected={
                  values.dateFormat
                    ? organizationData.DateFormat.filter(opt => opt.value === values.dateFormat)
                    : []
                }
                onChange={selected => {
                  const dateFormat = selected[0] as { value: string } | undefined;
                  setFieldValue('dateFormat', dateFormat ? dateFormat.value : '');
                }}
                clearButton
              />
              <ErrorMessage
                name="dateFormat"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>

          <Col sm="4">
            <FormGroup>
              <label>{t("Language")} <span className="txt-danger">*</span></label>
              <Typeahead
                id="languages-typeahead"
                labelKey="label"
                options={organizationData.languages}
                placeholder={t("LanguagePlaceholder")}
                multiple
                selected={
                  values.languages && Array.isArray(values.languages)
                    ? values.languages.map((lang: string) => organizationData.languages.find(opt => opt.value === lang)).filter((opt): opt is { value: string; label: string } => Boolean(opt))
                    : []
                }
                onChange={selected => {
                  setFieldValue('languages', selected.map((opt: any) => opt.value));
                }}
                clearButton
              />
              <ErrorMessage
                name="languages"
                component="span"
                className="text-danger"
              />
            </FormGroup>
          </Col>
        </Row>
      </CardBody>
    </div>
  );
};

export default GeneralSettingsSection; 